<template>
  <div class="overflow-hidden grid promo-cta__grid"
    :class="{ 'promo-cta__grid--image-right': contentPlacement === 'right' }" :data-skin="skin">
    <!-- Image Right Layout -->
    <template v-if="contentPlacement === 'right'">
      <div class="grid promo-cta__content">
        <h2 v-if="headline" class="promo-cta__headline" :id="headlineId">
          {{ headline }}
        </h2>
        <div v-if="description" class="promo-cta__body-copy" v-html="description"></div>
        <a v-if="cta && cta.url && cta.title" class="canvas-btn promo-cta__link" :href="cta.url" :target="cta.target"
          :data-skin="skin">
          <span class="canvas-btn__text-wrapper" :data-text="cta.title">
            <span class="canvas-btn__text">{{ cta.title }}</span>
          </span>
        </a>
      </div>
      <div v-if="image && image.url" class="relative h-full overflow-hidden">
        <svg class="promo-cta__graphic promo-cta__graphic--image-right promo-cta__graphic--desktop"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 331" fill="none" aria-hidden="true" :data-skin="skin">
          <circle cx="-837.5" cy="164.5" r="854.5" fill="currentColor" />
        </svg>
        <svg class="promo-cta__graphic promo-cta__graphic--mobile" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 358 57" fill="none" aria-hidden="true" :data-skin="skin">
          <circle cx="87" cy="929.397" r="929" fill="currentColor" />
        </svg>
        <div class="promo-cta__image-wrap promo-cta__image-wrap--right">
          <img class="cover" :src="image.url" :alt="image.alt" loading="lazy" />
        </div>
      </div>
      <div v-else class="promo-cta__fallback-graphic-wrap overflow-hidden">
        <img
          class="promo-cta__fallback-graphic promo-cta__fallback-graphic--image-right"
          :src="fallbackImage.url"
          :alt="fallbackImage.alt"
        />
      </div>
    </template>
    <!-- Image Left Layout -->
    <template v-else>
      <div v-if="image && image.url" class="relative h-full overflow-hidden">
        <svg class="promo-cta__graphic promo-cta__graphic--image-left promo-cta__graphic--desktop"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 331" fill="none" aria-hidden="true" :data-skin="skin">
          <circle cx="-837.5" cy="164.5" r="854.5" fill="currentColor" />
        </svg>
        <svg class="promo-cta__graphic promo-cta__graphic--mobile" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 358 57" fill="none" aria-hidden="true" :data-skin="skin">
          <circle cx="87" cy="929.397" r="929" fill="currentColor" />
        </svg>
        <div class="promo-cta__image-wrap promo-cta__image-wrap--left overflow-hidden">
          <img class="cover" :src="image.url" :alt="image.alt" />
        </div>
      </div>
      <div v-else class="promo-cta__fallback-graphic-wrap overflow-hidden">
        <img
          class="promo-cta__fallback-graphic promo-cta__fallback-graphic--image-left"
          :src="fallbackImage.url"
          :alt="fallbackImage.alt"
        />
      </div>
      <div class="grid promo-cta__content">
        <h2 v-if="headline" class="promo-cta__headline" :id="headlineId">
          {{ headline }}
        </h2>
        <div v-if="description" class="promo-cta__body-copy" v-html="description"></div>
        <a v-if="cta && cta.url && cta.title" class="canvas-btn promo-cta__link" :href="cta.url" :target="cta.target"
          :data-skin="skin">
          <span class="canvas-btn__text-wrapper" :data-text="cta.title">
            <span class="canvas-btn__text">{{ cta.title }}</span>
          </span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "PromoCta",
  props: {
    promo_cta: {
      type: Object,
      required: true,
    },
    fallback_image_dark: {
      type: Object,
      default: () => ({}),
    },
    fallback_image_light: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    headlineId() {
      // Generate a slug and unique id for the headline
      const slug = this.headline
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
      return `${slug}-${Math.random().toString(36).substr(2, 6)}`;
    },
    fallbackImage() {
      // If no image is provided, use fallback based on skin
      if (!this.image || !this.image.url) {
        if (this.skin === 'dark') {
          return this.fallback_image_dark;
        } else {
          return this.fallback_image_light;
        }
      }
      return this.image;
    },
  },
  setup(props) {
    const promo_cta = props.promo_cta;

    return {
      promo_cta: props.promo_cta,
      headline: promo_cta.headline,
      description: promo_cta.description,
      cta: promo_cta.cta,
      contentPlacement: promo_cta.content_placement,
      skin: promo_cta.color_theme,
      image: promo_cta.image,
    };
  },
};
</script>
